
export class User {
    id?: number;
    username: string;
    firstName: string;
    lastName: string;
    password: string;
    roles: string;
    location: string;
    country: string;

    constructor( username: string, firstName: string, lastName: string, password: string, roles: string, location: string, country: string = 'NL' ){
        this.username = username;
        this.firstName = firstName;
        this.lastName = lastName;
        this.password = password;
        this.roles = roles;
        this.location = location;
        this.country = country || 'NL';
    }
}
